import Vue from "vue";
import axios from "axios";

const state = {
	timeouterror: null,
	serverdownmessage: null,
	currentroute: null,
	access_token: null,
	authError: null,
	company_logo: null,
	_authloading_count: 0,
	_userloading_count: 0,
	_loading_count: 0,
	user: {},
	tenant_config: {},
	user_config: {},
	isTouch: false,
	primaryDrawer: JSON.parse(localStorage.getItem("primary_drawer")),
	isOffline: false,
	_config_loading: 0,
	lastClosedNotifications: JSON.parse(localStorage.getItem("last_closed_notifications")) || {},
};

const getters = {
	getCompanyLogo: (state) => state.company_logo,
	getCurrentRoute: (state) => state.currentroute,
	getAuthError: (state) => state.authError,
	getPrimaryDrawer: (state) => state.primaryDrawer,
	timeouterror: (state) => state.timeouterror,
	serverdownmessage: (state) => state.serverdownmessage,
	isAuthenticated: (state) => {
		return !!state.access_token;
	},
	is_authloading(state) {
		return state._authloading_count !== 0;
	},
	is_userloading(state) {
		return state._userloading_count !== 0;
	},
	is_loading(state) {
		return state._loading_count !== 0;
	},
	getUser: (state) => state.user,
	getUserConfig: (state) => state.user_config,
	getTenantConfig: (state) => state.tenant_config,
	isTouch: (state) => state.isTouch,
	isOffline: (state) => state.isOffline,
	config_loading: (state) => state._config_loading !== 0,
	getUserRole: (state) => state.user?.role ?? null,
	lastClosedNotifications: (state) => state.lastClosedNotifications,
};

const actions = {
	login({ commit, dispatch }, payload) {
		//
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/sanctum/token", payload)
				.then((res) => {
					if (res.data.token) {
						let access_token = "Bearer " + res.data.token;
						localStorage.setItem("access_token", access_token);
						commit("authSuccess", access_token);
						commit("setUser", res.data.user);
						commit("setCompanyLogo", res.data.company_logo);
						commit("setTenantConfig", res.data.config_tenat);
						commit("setUserConfig", res.data.config_user);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	logout({ commit }) {
		axios.post("/logout");
		commit("authLogout");
	},
	getCsrfCookie({ commit }) {
		return new Promise((resolve, reject) => {
			axios
				.get("/sanctum/csrf-cookie")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchUser({ commit }) {
		commit("START_USERLOADING");
		return new Promise((resolve, reject) => {
			axios
				.get("/api/user")
				.then((res) => {
					if (res.data) {
						commit("setCompanyLogo", res.data.company_logo);
						commit("setUser", res.data.user);
						commit("setTenantConfig", res.data.config_tenat);
						commit("setUserConfig", res.data.config_user);
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				})
				.then(function () {
					commit("STOP_USERLOADING");
				});
		});
	},
	verifyEmail: ({ commit, dispatch }, payload) => {
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.get("/api/email/verify/" + payload.id + "/" + payload.hash + "?expires=" + payload.expires + "&signature=" + payload.signature)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					switch (err.response.status) {
						case 403:
							commit("authError", "wrong_signature");
							break;
						case 410:
							commit("authError", "expired_link");
							break;
						case 401:
							commit("authError", "unauthorized");
							break;
						case 429:
							commit("authError", "toomanyrequest");
							break;
						default:
							commit("authError", "unexpected");
							break;
					}
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	askNewVerifyEmail: ({ commit, dispatch }, payload) => {
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.get("/api/email/askverify/" + payload.id + "/" + payload.hash + "?expires=" + payload.expires + "&signature=" + payload.signature)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					switch (err.response.status) {
						case 403:
							commit("authError", "wrong_signature");
							break;
						case 410:
							commit("authError", "expired_link");
							break;
						case 401:
							commit("authError", "unauthorized");
							break;
						case 429:
							commit("authError", "toomanyrequest");
							break;
						default:
							commit("authError", "unexpected");
							break;
					}
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	askResetPassword({ commit, dispatch }, payload) {
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/password/askreset", payload)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	resetPassword({ commit, dispatch }, payload) {
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/password/reset", payload)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	changePassword({ commit, dispatch }, params) {
		commit("START_AUTHLOADING");
		return new Promise((resolve, reject) => {
			axios
				.put("/api/changepassword/" + params.id, params)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_AUTHLOADING");
				});
		});
	},
	setTenantConfig({ commit, dispatch }, params) {
		commit("START_CONFIG_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.put("/api/tenant/update-settings", params)
				.then((res) => {
					if (res.data.object) {
						commit("setTenantConfig", res.data.object);
					}
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_CONFIG_LOADING");
				});
		});
	},
	setUserConfig({ commit, dispatch }, params) {
		commit("START_CONFIG_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.put("/api/user/update-settings", params)
				.then((res) => {
					if (res.data.object) {
						commit("setUserConfig", res.data.object);
					}
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_CONFIG_LOADING");
				});
		});
	},
};

const mutations = {
	authError(state, value) {
		Vue.set(state, "authError", value);
	},
	setCurrentRoute(state, value) {
		Vue.set(state, "currentroute", value);
	},
	authSuccess(state, access_token) {
		//
		state.access_token = access_token;
		window.axios.defaults.headers.common.Authorization = access_token;
	},
	authLogout(state) {
		//
		state.access_token = "";
		Vue.set(state, "user", {});
		localStorage.removeItem("access_token");
	},
	START_AUTHLOADING(state) {
		Vue.set(state, "authError", null);
		state._authloading_count++;
	},
	STOP_AUTHLOADING(state) {
		state._authloading_count--;
	},
	START_USERLOADING(state) {
		state._userloading_count++;
	},
	STOP_USERLOADING(state) {
		state._userloading_count--;
	},
	START_LOADING(state) {
		state._loading_count++;
	},
	STOP_LOADING(state) {
		state._loading_count--;
	},
	setUser(state, user) {
		Vue.set(state, "user", user);
	},
	setTenantConfig(state, data) {
		Vue.set(state, "tenant_config", data);
	},
	setUserConfig(state, data) {
		Vue.set(state, "user_config", data);
	},
	getAccessFromCookie(state) {
		Vue.set(state, "access_token", localStorage.getItem("access_token"));
		window.axios.defaults.headers.common.Authorization = localStorage.getItem("access_token");
	},
	setTimeout(state, value) {
		Vue.set(state, "timeouterror", value);
	},
	setServerDown(state, value) {
		if (state.authError == null) {
			Vue.set(state, "serverdownmessage", value);
		}
	},
	setTouchState(state, value) {
		Vue.set(state, "isTouch", value);
	},
	setPrimaryDrawer(state, value) {
		localStorage.setItem("primary_drawer", JSON.stringify(value));
		state.primaryDrawer = value;
	},
	setCompanyLogo(state, value) {
		Vue.set(state, "company_logo", value);
	},
	setOfflineState(state, value) {
		Vue.set(state, "isOffline", value);
	},
	START_CONFIG_LOADING(state) {
		state._config_loading++;
	},
	STOP_CONFIG_LOADING(state) {
		state._config_loading--;
	},
	UPDATE_TENANT_INFO(state, data) {
		let cloned = _.cloneDeep(state.user);
		cloned.tenant = data;
		Vue.set(state, "user", cloned);
	},
	setLastClosedNotifications(state, value) {
		localStorage.setItem("last_closed_notifications", JSON.stringify(value));
		Vue.set(state, "lastClosedNotifications", value);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
